import {
  IonCard,
  IonCardContent,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonItem,
  IonRow,
} from "@ionic/react";
import HeaderComponent from "../components/HeaderComponent";
import {
  pulseOutline,
  bookmarksOutline,
  batteryChargingOutline,
  timerOutline,
} from "ionicons/icons";
import { useAuth } from "./auth/AuthContext";
import "./Dashboard.css";
import { useEffect, useState } from "react";
import DeviceListTable from "../components/DeviceListTable";
import RadialBarComponent from "../components/RadialBarComponent";
import MapComponent from "../components/MapComponent";
import { useSelector } from "react-redux";

const Dashboard: React.FC = () => {
  const { authInfo } = useAuth()!;
  const [userMetadata, setUserMetadata] = useState<any>({});
  const dashboardMap = useSelector((state: any) => state.dashboardData);
  const [totalDevices, setTotalDevices] = useState(0);
  const [sohAvg, setSohAvg] = useState(0);
  const [socAvg, setSocAvg] = useState(0);
  const [capAvg, setCapAvg] = useState(0);
  useEffect(() => {
    setUserMetadata(authInfo.userMetadata);
    if (dashboardMap !== undefined) {
      // console.log("dashboardMap: " + Object.keys(dashboardMap).length);
      const reduce_data = dashboardMap.reduce((obj: any, d: any) => {
        let key = d.reserved;
        obj[key] = obj[key] || {
          ...d,
          soc: 0,
          soh: 0,
          availableCap: 0,
        };
        obj[key]["soc"] += +d["soc"];
        obj[key]["soh"] += +d["soh"];
        obj[key]["availableCap"] += +d["availableCap"];

        return obj;
      }, {});
      setTotalDevices(Object.keys(dashboardMap).length);
      setSocAvg(reduce_data[0].soc / Object.keys(dashboardMap).length);
      setSohAvg(reduce_data[0].soh / Object.keys(dashboardMap).length);
      setCapAvg(reduce_data[0].availableCap);
      // console.log("dashboardReducedMap: " + reduce_data[0]);
    }
  });
  const tiles = [
    {
      icon: bookmarksOutline,
      text: "Total Devices",
      value: totalDevices,
    },
    {
      icon: pulseOutline,
      text: "SOH (%)-Average",
      value: sohAvg,
    },
    {
      icon: batteryChargingOutline,
      text: "SOC (%)-Average",
      value: socAvg,
    },
    {
      icon: timerOutline,
      text: "Capacity (Ah)",
      value: capAvg,
    },
  ];

  return (
    <IonContent fullscreen>
      <HeaderComponent title={"Dashboard"} />
      <IonGrid>
        <IonRow>
          {tiles.map((tile, index) => {
            return (
              <IonCol key={index}>
                <IonItem color="light">
                  <IonIcon
                    icon={tile.icon}
                    className="iconplace"
                    size="large"
                  />
                  <IonCardContent>
                    <h1>{tile.value}</h1>
                    <p color="primary">{tile.text}</p>
                  </IonCardContent>
                </IonItem>
              </IonCol>
            );
          })}
        </IonRow>
        <IonRow>
          <IonCol sizeSm="12" sizeMd="6" sizeLg="6">
            <IonCard
              color="light"
              className="customRow align-items-center justify-content-center"
            >
              <RadialBarComponent />
            </IonCard>
          </IonCol>
          <IonCol sizeSm="12" sizeMd="6" sizeLg="6">
            <IonCard color="light" className="customRow">
              <MapComponent />
            </IonCard>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol sizeSm="12" sizeMd="12" sizeLg="12">
            <DeviceListTable />
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonContent>
  );
};

export default Dashboard;
